module.exports = __webpack_public_path__ + "static/media/icon_all-about-me.c5728ac3.svg";